export default __webpack_public_path__ + "static/media/classic1.b467b3fc.jpg";